export default __webpack_public_path__ + "static/media/About_IMG-Integrity.8a46ad93.png";